import React, { Component } from 'react'

export default class WebpImage extends Component {
  render() {
    return (
      <picture>
        <source srcSet={this.props.webpsrc} type="image/webp" />
        <source srcSet={this.props.src} type="image/jpeg" />
        <img
          className={this.props.className}
          alt={this.props.alt}
          src={this.props.src}
          onClick={this.props.onClick}
          draggable={false}
        />
      </picture>
    )
  }
}
